import axios from "axios";
import { deleteAllCookies, isEmpty, isEmptyObject } from "./tools";
import Cookies from "js-cookie";
import { _ckey } from "../address";
import { useSelector } from "react-redux";
import { useAPIPublic } from "./api";

export const app_Cookie = (key, value, issecure = false) => {
  try {
    if (!isEmpty(value)) {
      if (!issecure) {
        localStorage.setItem(key, value);
        // Cookies.set(key, value, {
        //   domain: process.env.REACT_APP_DOMAIN,
        //   secure: false,
        // });
      } else {
        // Cookies.set(key, value, { domain: process.env.REACT_APP_DOMAIN });
        localStorage.setItem(key, value);
      }
    } else {
      // return Cookies.get(key);
      return localStorage.getItem(key);
    }
  } catch (error) {
    return "";
  }
};

export const app_Cookie_Remove = async (key) => {
  try {
    Cookies.remove(key);
  } catch (error) {
    return "";
  }
};

export const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const setToken = async (values) => {
  return new Promise((resolve) => {
    app_Cookie(_ckey.expireUTCTime, values.expireUTCTime);
    setLocalStorage(_ckey.token, values.token);

    // axios.defaults.headers.common["token"] = setToken.token;
    resolve();
  });
};
export const setSessionStorage = (name, values) => {
  try {
    return sessionStorage.setItem(name, values);
  } catch (error) {
    return "";
  }
};
export const getSessionStorage = (name) => {
  try {
    return sessionStorage.getItem(name);
  } catch (error) {
    return "";
  }
};
export const setLocalStorage = (name, values) => {
  try {
    return localStorage.setItem(name, values);
  } catch (error) {
    return "";
  }
};
export const getLocalStorage = (name) => {
  try {
    return localStorage.getItem(name);
  } catch (error) {
    return "";
  }
};
export const CheckToken = () => {
  const { refreshToken } = useAPIPublic();
  return new Promise(async (resolve) => {
    try {
      let _token = getLocalStorage(_ckey.token);
      let _expireUTCTime = app_Cookie(_ckey.expireUTCTime);
      if (isEmpty(_token) || isEmpty(_expireUTCTime)) {
        resolve(false);
        return;
      }
      // const { global } = useSelector((state) => state);
      // if (!global?.resUser) {
      //   resolve(false);
      //   return;
      // }
      // let persist = !isEmpty(localStorage.getItem("persist:root")) ? JSON.parse(localStorage.getItem("persist:root")) : {};

      // if (!persist?._currentUser) {
      //   resolve(false);
      //   return;
      // }

      setToken({ token: _token, expireUTCTime: _expireUTCTime });
      if (!isEmpty(_token) && !isEmpty(_expireUTCTime)) {
        var year = parseInt(_expireUTCTime.split("T")[0].split("-")[0]),
          month = parseInt(_expireUTCTime.split("T")[0].split("-")[1]),
          day = parseInt(_expireUTCTime.split("T")[0].split("-")[2]),
          hours = parseInt(_expireUTCTime.split("T")[1].split(".")[0].split(":")[0]),
          minutes = parseInt(_expireUTCTime.split("T")[1].split(".")[0].split(":")[1]),
          second = parseInt(_expireUTCTime.split("T")[1].split(".")[0].split(":")[2]);
        var utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes, second));
        var distance = utcDate - new Date();
        if (distance <= 600000) {
          let payload = {
            token: _token,
          };
          let response = await refreshToken(payload);
          if (response) {
            await setToken({
              token: response.token,
              expireUTCTime: response.expireUTCTime,
            });
            setAuthorization(response.token);
          } else {
            resolve(false);
          }
        } else {
          resolve(true);
        }
      } else {
        resolve(false);
      }
    } catch (error) {
      console.log(error);
      resolve(false);
    }
  });
};
export const clearApp = () => {
  return new Promise(async (resolve, reject) => {
    try {
      sessionStorage.clear();
      localStorage.clear();
      await deleteAllCookies();
      return resolve(true);
    } catch (error) {
      reject(false);
    }
  });
};

export const DocType = {
  PreparednessCard: "PreparednessCard",
  Passport: "Passport",
  BirthCertificate: "BirthCertificate",
  DrivingLicense: "DrivingLicense",
  CertNoCard: "CertNoCard",
  SIMCardPuck: "SIMCardPuck",
  Other: "Other",
  RequestDoc: "RequestDoc",
  SPDocument: "SPDocument",
  SWDocument: "SWDocument",
  IdentityCard: "IdentityCard",
  RefugeeCard: "RefugeeCard",
  CODocument: "CODocument",
};
export const CertType = {
  NationalNo: 0,
  PassportNo: 1,
  PreparednessCard: 2,
  RefugeeCard: 3,
  IdentityCard: 4,
};

export const Roles = {
  Global: "global",
  Show_OTPCode_ToDealer: "Show_OTPCode_ToDealer",
  UpdateDealerWallet: "UpdateDealerWallet",
  Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc: "Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc",
  APIQueryWalletAmount: "APIQueryWalletAmount",
  Dealer_RegisterSim_Report_UploadingDoc: "Dealer_RegisterSim_Report_UploadingDoc",
  UpdateDealerWalletByCurrentUser: "UpdateDealerWalletByCurrentUser",
  Dealer_Wallet_Management: "Dealer_Wallet_Management",
  Dealer_ChangeOwner_Report_One: "Dealer_ChangeOwner_Report_One",
  SimSwapDealer: "SimSwapDealer",
  ByPassDocumentUploudSimswap_ByDealer: "ByPassDocumentUploudSimswap_ByDealer",
  Dealer_EPPurchase_ReportOne: "Dealer_EPPurchase_ReportOne",
  Dealer_RegisterSim_B2C_NonIranian: "Dealer_RegisterSim_B2C_NonIranian",
  Dealer_DCPurchase_B2C: "Dealer_DCPurchase_B2C",
  SimRegistrationDelear: "SimRegistrationDelear",
  Dealer_EPPurchase_B2C: "Dealer_EPPurchase_B2C",
  Dealer_SimSwap_B2C_Iranian: "Dealer_SimSwap_B2C_Iranian",
  Dealer_RegisterSim_B2C_Iranian: "Dealer_RegisterSim_B2C_Iranian",
  CreateUserMenue: "CreateUserMenue",
  APICheckSubscriberIsAllowToSales: "APICheckSubscriberIsAllowToSales",
  Dealer_SimSwap_B2C_Iranian_DeliveryAreas: "Dealer_SimSwap_B2C_Iranian_DeliveryAreas",
  Dealer_DCPurchase_ReportOne: "Dealer_DCPurchase_ReportOne",
  Security_API: "Security_API",
  Dealer_ChangeOwner_B2C_Iranian: "Dealer_ChangeOwner_B2C_Iranian",
  NeginTel_API: "NeginTel_API",
  Dealer_ChangeOwner_Report_UploadingDoc: "Dealer_ChangeOwner_Report_UploadingDoc",
  Dealer_SimSwap_Report_UploadingDoc: "Dealer_SimSwap_Report_UploadingDoc",
  Dealer_SimSwap_B2B_Iranian: "Dealer_SimSwap_B2B_Iranian",
  Dealer_SimSwap_Report_One: "Dealer_SimSwap_Report_One",
  Didban_API: "Didban_API",
  APIQueryOffer: "APIQueryOffer",
  Dealer_API: "Dealer_API",
  SalesChargeDelaer: "SalesChargeDelaer",
  USSD_API: "USSD_API",
  Public_API: "Public_API",
  Dealer_RegisterSim_Report_One: "Dealer_RegisterSim_Report_One",
  SalesEPackageDelaer: "SalesEPackageDelaer",
  Dealer: "Dealer",
  User_Can_SimSwap_B2B: "User_Can_SimSwap_B2B",
  Dealer_Wallet_AccessCC: "Dealer_Wallet_AccessCC",
  Dealer_Wallet_AccessCP: "Dealer_Wallet_AccessCP",
  Dealer_Wallet_AccessOtherSales: "Dealer_Wallet_AccessOtherSales",
  Dealer_Wallet_AccessAsanWallet: "Dealer_Wallet_AccessAsanWallet",
  Dealer_SimSwap_B2C_UploadPassportDoc: "Dealer_SimSwap_B2C_UploadPassportDoc",
  Dealer_RegisterSim_B2C_UploadPassportDoc: "Dealer_RegisterSim_B2C_UploadPassportDoc",
  Dealer_RegisterSim_Allow_Get_Signature_FromCustomer: "Dealer_RegisterSim_Allow_Get_Signature_FromCustomer",
  CRM_RegisterSim_Catable_Post: "CRM_RegisterSim_Catable_Post",
  Dealer_RegisterSim_Allow_Select_Method_Of_Receipt: "Dealer_RegisterSim_Allow_Select_Method_Of_Receipt",
};
